import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Row, Col, Label } from 'reactstrap';
import classNames from 'classnames';

import {SYSTEMS_OF_MEASURE} from '../../../constants/uom';
import { STANDARD_TEMPLATE, RESULTS_TEMPLATE } from '../../../constants/reportLayouts';
import Card from '../../shared/Card';
import Button from '../../shared/Button';
import ResultBreakPoints from '../ResultBreakPoints';
import ResultBreakPointsModal from '../ResultBreakPointsModal';

import styles from './styles.scss';


const propTypes = {
  highLevel: PropTypes.number,
  lowLevel: PropTypes.number,
  uom: PropTypes.string,
  template: PropTypes.string,
  isSubStandard: PropTypes.bool,
  changeBreakPoints: PropTypes.func,
  changeTemplate: PropTypes.func,
};

class TemplateOptions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };
    this.toggleModal = this.toggleModal.bind(this);
  }

  toggleModal() {
    this.setState({
      modal: !this.state.modal
    });
  }

  render() {
    const {
      highLevel,
      lowLevel,
      uom,
      template,
      changeBreakPoints,
      changeTemplate,
      isSubStandard
    } = this.props;

    const radonUnits = SYSTEMS_OF_MEASURE[uom].radon;
    const isStandardTemplate = template === STANDARD_TEMPLATE;

    return (
      <Card header='Template Options for Basic Reports and Official Report Email Content'>
        <Row>
          <Col className='mb-4'>
            <Label check>
              <input
                className='mr-2'
                type='radio'
                value={STANDARD_TEMPLATE}
                name='template'
                checked={isStandardTemplate}
                onClick={changeTemplate}
              />
              Standard Template
            </Label>
          </Col>
          <Col className={classNames('mb-4', {
            [styles.disabled]: isSubStandard
          })}>
            <Label check>
              <input
                className='mr-2'
                type='radio'
                value={RESULTS_TEMPLATE}
                name='template'
                checked={!isStandardTemplate}
                onClick={!isSubStandard ? changeTemplate : () => { }}
              />
              Template Based on Result
            </Label>
          </Col>
        </Row>
        <Row>
          <Col className={{
            'mb-3': true,
            [styles.disabled]: isStandardTemplate
          }}>
            <ResultBreakPoints
              high={highLevel}
              low={lowLevel}
              units={radonUnits}
            />
          </Col>
        </Row>
        <If condition={!isStandardTemplate}>
          <Row>
            <Col className='text-right'>
              <Button
                kind='primary'
                onClick={this.toggleModal}>
                Change Result Ranges
              </Button>
              <ResultBreakPointsModal
                high={highLevel}
                low={lowLevel}
                units={radonUnits}
                isOpen={this.state.modal}
                toggle={this.toggleModal}
                changeBreakPoints={changeBreakPoints}
              />
            </Col>
          </Row>
        </If>
      </Card>
    );
  }
}

TemplateOptions.propTypes = propTypes;

const mapStateToProps = ({ profile }) => ({
  isSubStandard: profile.isSubStandard
});

export default connect(mapStateToProps)(TemplateOptions);



// WEBPACK FOOTER //
// src/components/reportManagement/TemplateOptions/index.jsx